module.exports = __webpack_public_path__ + "img/good.a475d20e.png";